<template>
    <div class="confirmloan_vfd">
        <van-nav-bar
                title=""
                left-text=""
                right-text=""
                left-arrow
                @click-left="onClickLeft"
                @click-right="onClickRight"
        >
            <template #left>
                <van-icon name="arrow-left" color="#000000" />
                <span>Volver</span>
            </template>
        </van-nav-bar>
        <van-pull-refresh v-model="isLoanLoading" @refresh="onRefresh"
                          pulling-text="Se puede actualizar desplegando..."
                          loosing-text="Se puede actualizar liberando..."
                          loading-text="En carga..."
        >
            <div class="audithome_wrap" id="firstloan_head">
                <div class="audithome_head">
                    <div class="audithome_hleft">Superapoyomax</div>
                    <div class="audithome_hright">
                        <div class="audithome_hrimg">
                            <!--<img src="../../assets/img/audithome_icon01.png" />-->
                        </div>
                        <div class="audithome_hrimg" @click.stop="onHomeMenus">
                            <!--<img src="../../assets/img/audithome_icon02.png" />-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="confirmloan_wrap">
                <div class="confirmloan_cont">
                    <div class="confirmloan_ctoptitle">Monto del préstamo</div>
                    <div class="confirmloan_ctopdesc"><span>$</span>{{ loanAmount }}</div>

                    <div class="mobhome_tview">
                        <!--<div class="sliderbox_wrap">
                            <div class="sliderbox_left">
                                <div class="sliderbox_cimg">
                                    <img class="eshoy_gold_small" src="../../assets/img/eshoy_gold_small.png" alt="">
                                </div>
                                <div class="sliderbox_ctext" v-if="products">
                                    $<span>{{ products.mir_env_pfp }}</span>
                                </div>
                            </div>
                            <div class="sliderbox_middle" v-if="products">
                                <div class="sliderBox">

                                    <van-slider
                                            v-model="sliderValue"
                                            :min="products.mir_env_pfp"
                                            :max="products.aft_hws_cuj"
                                            :step="50"
                                            bar-height="6px"
                                            inactive-color="D8D8D8"
                                            @change="onSliderChange"
                                    >
                                    </van-slider>

                                </div>
                            </div>
                            <div class="sliderbox_right">
                                <div class="sliderbox_cimg">
                                    <img class="eshoy_gold_more" src="../../assets/img/eshoy_gold_more.png" alt="">
                                </div>
                                <div class="sliderbox_ctext">
                                    <div class="sliderbox_ctext_view" v-if="products">
                                        $<span>{{ products.aft_hws_cuj }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>-->
                    </div>

                    <div class="confirmloan_cmain">
                        <div class="confirmloan_cmtitle">Plan de reembolso</div>
                        <div class="confirmloan_cmview">

                            <div class="confirmloan_cmitems itoken_checkvi_scale-1px">
                                <div class="confirmloan_cmileft">Plazo（días）</div>
                                <div class="confirmloan_cmiright" v-if="calculationInfo">{{ calculationInfo.sas_dsz_vuf }} Días</div>
                            </div>

                            <div class="confirmloan_cmitems itoken_checkvi_scale-1px">
                                <div class="confirmloan_cmileft">Fecha del pago</div>
                                <div class="confirmloan_cmiright" v-if="calculationInfo">{{ calculationInfo.luc_nhd_dmo }}</div>
                                <!--payTimes-->
                            </div>

                            <!--<div class="itoken_check_vitems itoken_checkvi_scale-1px" @click="gotoBank">
                                <div class="itoken_check_vitem">
                                    <div class="itoken_check_vitop">
                                        <div class="itoken_check_vitleft_coupon">
                                            <img src="@/assets/mobimg/confirm_icon01.png" alt="">
                                            <span style="font-size: 0.388889rem;">Tarjeta bancaria</span>
                                        </div>
                                        <div class="itoken_check_vitright">
                                            <div class="itoken_check_vitrnums" style="font-weight: 400;">
                                                <template v-if="bankCode">
                                                    {{bankCode | hideBankcode}}
                                                </template>
                                                <template v-else>
                                                    &#45;&#45;
                                                </template>
                                            </div>
                                            <div class="itoken_check_vitrarrow">
                                                <img src="@/assets/mobimg/comf_rparrow.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>-->


                            <div class="itoken_check_vitems itoken_check_vitems_coupons itoken_checkvi_scale-1px" @click="gotoCoupons">
                                <div class="itoken_check_vitem">
                                    <div class="itoken_check_vitop itoken_check_vitop_new">
                                        <div class="itoken_check_vitleft_coupon">
                                            <img src="@/assets/mobimg/itoken_check_vitleft_coupon.png" alt="">
                                            <span style="font-size: 0.388889rem;">Cupón</span>
                                        </div>
                                        <div class="itoken_check_vitright">
                                            <div class="itoken_check_vitrnums" style="font-weight: 400;">
                                                <template v-if="couponsList && couponsList.length">
                                                    <template v-if="couponsObj && couponsObj.coupon_type">
                                                        <template v-if="couponsObj.coupon_type == 1">
                                                            <p style="color: #DB861F;">
                                                                <span style="color: #DB861F;">-</span>${{couponsObj.distribute_amount}}
                                                            </p>
                                                        </template>
                                                        <template v-else-if="couponsObj.coupon_type == 4">
                                                            <p style="color: #DB861F;">
                                                                <span style="color: #DB861F;">+</span>${{couponsObj.distribute_amount}}
                                                            </p>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <span>{{couponsList.length}}</span>disponible(s)
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    No utilizar el cupón
                                                </template>
                                            </div>
                                            <div class="itoken_check_vitrarrow">
                                                <img src="@/assets/mobimg/comf_rparrow.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="itoken_check_vidown" v-if="couponsObj && couponsObj.coupon_type">
                                        <div class="itoken_check_vidleft"></div>
                                        <div class="itoken_check_vidright">
                                            <template v-if="couponsObj.coupon_type == 4">
                                                Cupón de monto adicional
                                            </template>
                                            <template v-else-if="couponsObj.coupon_type == 1">
                                                Cupón de pago
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="confirmloan_cmitems" @click="onShowPayment">
                                <div class="confirmloan_cmileft">Monto del pago</div>
                                <div class="confirmloan_cmiright">
                                    <div class="confirmloan_cmirview">
                                        <div class="confirmloan_cmirvl" v-if="calculationInfo">
                                            <template v-if="calculationInfo.myi_hop_pek || calculationInfo.myi_hop_pek == 0">
                                               <!--<span>$ {{payAmount}}</span>-->
                                                ${{ calculationInfo.myi_hop_pek }}
                                            </template>
                                            <template v-else>
                                                --
                                            </template>
                                        </div>
                                        <div class="confirmloan_cmirvr">
                                            <img src="@/assets/mobimg/confirm_icon02.png" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="confirmloan_cmcontrato_wrap">
                        <div class="confirmloan_cmcontrato_cont">
                            <div class="confirmloan_cmcontrato_cleft">
                                <van-checkbox v-model="contratoChecked">
                                    <template #icon="props">
                                        <img v-if="props.checked" src="@/assets/mobimg/contrato_ischeck.png" alt="">
                                        <img v-else src="@/assets/mobimg/contrato_nocheck.png" alt="">
                                    </template>
                                    <template #default>
                                        He leído y acepto el
                                    </template>
                                </van-checkbox>
                            </div>
                            <div class="confirmloan_cmcontrato_cright" @click="gotoLoan"><span>contrato de préstamo</span></div>
                        </div>
                    </div>

                    <van-button round color="#00CA88" block style="height: 1.222222rem;" @click="onConfirm">
                        <span style="font-size: 0.444444rem; font-weight: bold;">Recibir el dinero</span>
                    </van-button>
                </div>

                <van-popup v-model="confirmShow" position="bottom" round>
                    <div class="verifycode_wrap">
                        <div class="verifycode_cont">
                            <div class="verifycode_tilte"></div>
                            <div class="verifycode_top verifycode_coupons_top">
                                <div class="verifycode_tleft">
                                    <span>
                                        Detalles
                                    </span>
                                </div>
                                <div class="verifycode_tright" @click="confirmShow = false">
                                    <img src="@/assets/mobimg/verifycode_tright.png" alt="">
                                </div>
                            </div>

                            <div class="confirmloan_msgwrap">
                                <div class="confirmloan_msgitems">
                                    <div class="confirmloan_msgileft">Monto de préstamo</div>
                                    <div class="confirmloan_msgiright">$<span v-if="calculationInfo">{{ calculationInfo.mhv_cjz_hgv }}</span></div>
                                </div>
                                <div class="confirmloan_msgitems">
                                    <div class="confirmloan_msgileft">Interés</div>
                                    <div class="confirmloan_msgiright">$<span v-if="calculationInfo">{{ calculationInfo.kmi_eve_gzt }}</span></div>
                                </div>
                                <div class="confirmloan_msgitems">
                                    <div class="confirmloan_msgileft">Comisión</div>
                                    <div class="confirmloan_msgiright">$<span v-if="calculationInfo">{{ calculationInfo.qij_wyk_ywo }}</span></div>
                                </div>
                                <div class="confirmloan_msgitems">
                                    <div class="confirmloan_msgileft">VAT</div>
                                    <div class="confirmloan_msgiright">$<span v-if="calculationInfo">{{ calculationInfo.hkf_frh_klx }}</span></div>
                                </div>
                            </div>

                            <div class="verifycode_footer_btns" @click="confirmShow = false">
                                <div class="verifycode_footer_btn">
                                    <van-button round color="#00CA88" block>
                                        <span style="font-size: 0.444444rem; font-weight: bold;">Enterado</span>
                                    </van-button>
                                </div>
                            </div>

                        </div>
                    </div>
                </van-popup>
            </div>
        </van-pull-refresh>

        <!--<van-tabbar v-model="tabactive" active-color="#19A95C" inactive-color="#999999" @change="onTabChange">
            <van-tabbar-item icon="wap-home">Inicio</van-tabbar-item>
            <van-tabbar-item icon="contact">Yo</van-tabbar-item>
        </van-tabbar>-->
    </div>
</template>

<script>
    import { parseTime, getNextDate, getQueryString } from "@/utils/index"
    import store from '@/store';

    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { getAccessToken } from '@/utils/auth';

    import { getLoanInfo, confirmLoan, calculationTrial, confirmOrder } from '@/api/loan'

    import { Toast } from 'vant';


    export default {
        name: 'confirmloan',
        data() {
            return {
                tabactive: 0,
                sliderValue: 0,
                radioDays: 30,
                contratoChecked: true,
                confirmShow: false,
                loanAmount: null,
                loanDays: null,
                payTimes: null,
                bankCode: null,
                couponsList: [],
                couponsObj: null,
                payAmount: null,
                interest_fee: null, //利息
                fee: null, //服务费
                vat: null,
                shouPay: null,
                origin_contract_amount: 0,
                coupon_type: 0,
                isLoanLoading: false,
                products: null,
                calculationInfo: null,
            }
        },
        mounted() {
            let _this = this;

            let product_id = this.$store.state.common.productId;

            let productinfo_str = this.$store.state.common.productInfo;

            if(productinfo_str) {
                this.products = JSON.parse(productinfo_str);
                let productinfo_json = JSON.parse(productinfo_str);
                this.getCalculationTrial(productinfo_json)
            }

            let loanAmount = this.getQueryString('amount');

            this.sliderValue = Number(loanAmount);

            this.loanAmount = loanAmount;

            console.log(product_id);

            //this.gotoStatus();

            /*setTimeout(() => {
                _this.$toast.clear();
                let result = {
                    "bank_card_type": 1,
                    "bank_name": "STP",
                    "bank_no": "324364575678354345",
                    "contract_amount": 509,
                    "coupon_amount": 0,
                    "coupon_type": 0,
                    "current_step": 0,
                    "fee": 54, //服务费
                    "have_unused_count": 0,
                    "interest_fee": 40, //利息
                    "loan": 400, //借款
                    "origin_contract_amount": 509,
                    "origin_loan": 400,
                    "period": 10,
                    "repay_interest": 40,
                    "repay_time": "30/04/2023",
                    "server_time": 1682061491274,
                    "vat": 15
                };

                _this.loanAmount = result.loan;
                _this.loanDays = result.period;
                _this.bankCode = result.bank_no;
                _this.payTimes = result.repay_time;
                _this.payAmount = result.origin_contract_amount;
                _this.interest_fee = result.interest_fee;
                _this.fee = result.fee;
                _this.vat = result.vat;

            }, 200);*/
        },
        filters: {
            hideBankcode(val) {
                if (val) {
                    return `${val.substring(0, 4)}******${val.substring(val.length - 4)}`;
                }
            }
        },
        methods: {
            onClickLeft() {
                this.$router.back();
            },
            onClickRight() {

            },
            onTabChange(item) {
                if(item == 0){
                    this.$router.replace({
                        path: '/loanpage/confirmloan'
                    })
                } else if(item == 1){
                    this.$router.push({
                        path: '/loanpage/usercenter'
                    })
                }
            },
            gotoLoan() {
                // this.$router.push({
                //     path: '/loanpage/loanagreement'
                // })
            },
            getQueryString(name) {
                var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
                var r = window.location.search.substr(1).match(reg);
                if (r != null) {
                    return unescape(r[2]);
                }
                return null;
            },
            gotoCoupons() {

            },
            onShowPayment() {
                this.confirmShow = true;
            },
            onSliderChange(value) {
                console.log(value)
                this.calculationInfo = null;
                this.sliderValue = value;
                this.loanAmount = value;
                let products = this.products;
                if(products){
                    this.getCalculationTrial(products);
                }
            },
            async getCalculationTrial(productInfo){
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let sliderValue = this.sliderValue;

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                        llg_pys_mii: '1',
                        lck_olj_vmv: String(sliderValue),
                        sas_dsz_vuf: String(productInfo.uyo_mbc_sie),
                        oti_fmd_qms: productInfo.id_str,
                        // lck_olj_vmv: '200',
                        // sas_dsz_vuf: '7',
                        // oti_fmd_qms: '2013078303100007002',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    calculationTrial(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                if(useDataJSON){
                                    this.calculationInfo = useDataJSON;

                                    // 本金 loan lck_olj_vmv
                                    // 利息 interest_fee kmi_eve_gzt
                                    // 税费 vat hkf_frh_klx
                                    // 服务费 fee qij_wyk_ywo

                                }
                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });
                } else { //未登录
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
            onConfirm() {
                console.log(11111)
                let _this = this;
                this.confirmorder();
            },
            onCheckTokenKey() {
                let tokenKey = this.$store.state.common.tokenKey;

                if(tokenKey && tokenKey.length > 0){
                    this.onConfirmOrder(tokenKey);
                } else {
                    let _this = this;
                    setTimeout(() => {
                        client.record("login").then((r) => {
                            console.log(r);
                            //localStorage.setItem("tokenKey", r);
                            _this.$store.commit('common/SET_TOKEN_KEY', r);

                            _this.onConfirmOrder(r);
                        });
                    }, 10);
                }
            },
            async onConfirmOrder(tokenKey) {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let loanAmount = this.loanAmount;

                    let productInfo = this.products;

                    console.log('产品信息');
                    console.log(productInfo)

                    let  postData = {
                            zzm_yya_hqb: getAccessToken(),
                            aaa_off_csl: '111',
                            vjk_fjt_bvh: tokenKey,
                            lck_olj_vmv: String(loanAmount),
                            sas_dsz_vuf: String(productInfo.uyo_mbc_sie),
                            oti_fmd_qms: productInfo.id_str,
                            bpb_imu_jqa: '',
                            fkc_cmc_zbn: '',
                            doe_ody_zty: '',
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };

                    loadingShow();
                    confirmOrder(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                if(useDataJSON){
                                    _this.$store.commit('common/SET_PRODUCT_ID', productInfo.id_str);
                                    _this.$router.replace({
                                        path: '/loanpage/loanstatus'
                                    });
                                }
                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                    });
                } else { //未登录
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
            async confirmorder(){
                let _this = this;
                //this.confirmShow = true;
                let usecontratoChecked = this.contratoChecked;
                if(usecontratoChecked){

                    this.onCheckTokenKey();

                    /*const login_token = getAccessToken();
                    console.log(login_token)
                    if(login_token){ //已经登录
                        console.log('已登录11111')
                        let time_zone = getTimezoneName();
                        console.log(time_zone);
                        loadingShow();
                        let ip = await getUserIp()
                        console.log(ip)

                        let loanAmount = this.loanAmount;
                        let loanDays = this.loanDays;

                        let productId = this.$store.state.common.productId;

                        let products = this.products;

                        let postData = {
                            zzm_yya_hqb: getAccessToken(),
                            lck_olj_vmv: String(loanAmount),
                            bpb_imu_jqa: '',
                            sas_dsz_vuf: String(products.uyo_mbc_sie),
                            oti_fmd_qms: productId,
                            nen_cog_yim: String(loanAmount),
                            jba_hmp_qjh: String(loanAmount),
                            aaa_off_csl: '111',
                        };

                        loadingShow();
                        confirmLoan(postData, {
                            'bwd-irh-lnf': time_zone,
                            'xfo-plp-van': ip
                        }).then(res => {
                            console.log(res)
                            loadingHide()
                            if(res.ci == 200){
                                let useData = res.da;
                                console.log(JSON.parse(useData))
                                if(useData){
                                    let useDataJSON = JSON.parse(useData);
                                    if(useDataJSON){
                                        _this.$router.replace({
                                            path: '/loanpage/loanstatus'
                                        });
                                    }
                                }
                            } else {
                                Toast(res.ms);
                            }
                        }, error => {
                            loadingHide()
                        });
                    } else { //未登录
                        this.$router.replace({
                            path: '/loanpage/loginhome'
                        })
                    }*/

                } else {
                    this.$toast('Por favor, acepte el acuerdo primero') //请同意协议
                }
            },
            onRefresh() {
                this.isLoanLoading = true;
                this.gotoStatus();
            },
            async gotoStatus() {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                    };

                    loadingShow();
                    getLoanInfo(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.isLoanLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);
                                let { vkt_fnd_yzo, ojq_dzg_oxq } = useDataJSON;

                                if(vkt_fnd_yzo){
                                    let { hxo_gjz_xif, nen_cog_yim, nlb_phe_yac, lks_dol_bul, pri_jrg_ucv, hkf_frh_klx, luc_nhd_dmo } = vkt_fnd_yzo;


                                    console.log('bank_no:' + hxo_gjz_xif)
                                    console.log('loan_amount' + nen_cog_yim)
                                    console.log('loan_term' + nlb_phe_yac)
                                    console.log('repay_interest' + lks_dol_bul)
                                    console.log('service_fee' + pri_jrg_ucv)
                                    console.log('vat' + hkf_frh_klx)
                                    console.log('repay_time' + luc_nhd_dmo)

                                    let totalAmount = Number(nen_cog_yim) + Number(lks_dol_bul) + Number(pri_jrg_ucv) + Number(hkf_frh_klx);

                                    _this.loanAmount = nen_cog_yim;
                                    _this.loanDays = nlb_phe_yac;
                                    _this.bankCode = hxo_gjz_xif;
                                    _this.payTimes = luc_nhd_dmo;
                                    _this.payAmount = totalAmount;
                                    _this.interest_fee = lks_dol_bul;
                                    _this.fee = pri_jrg_ucv;
                                    _this.vat = hkf_frh_klx;

                                    // bank_no hxo_gjz_xif
                                    // vat hkf_frh_klx
                                    // loan_amount nen_cog_yim
                                    // service_fee pri_jrg_ucv
                                    // repay_interest lks_dol_bul
                                    // repay_time luc_nhd_dmo
                                    // loan_term nlb_phe_yac


                                    //order_status, reapply_time, current_is_reloan,
                                    let { omi_fje_qly, huw_kdq_nxo, xhi_cur_ovl,  } = vkt_fnd_yzo;

                                    console.log(omi_fje_qly);
                                    console.log(huw_kdq_nxo);
                                    console.log(ojq_dzg_oxq);
                                    console.log(xhi_cur_ovl);

                                    //               order_status, reapply_time, server_time, current_is_reloan,
                                    //this.getStatus(omi_fje_qly, huw_kdq_nxo, ojq_dzg_oxq, xhi_cur_ovl, _this);
                                }

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.isLoanLoading = false;
                    });
                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                    //this.gotoLogin();
                }
            },
            gotoBank() {

            },
        }
    }
</script>
<style scss scoped>
    .confirmloan_vfd{
        width: 100%;
        height: 100vh;
    }
    .audithome_wrap{
        width: 100%;
        height: 9.861111rem;
        background: linear-gradient(180deg, #19A95C 0%, #F6F6F6 100%);
    }
    .audithome_head{
        width: 100%;
        height: 1.333333rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 0.444444rem;
    }
    .audithome_hleft{
        width: 5.555556rem;
        height: 0.583333rem;
        font-size: 0.5rem;
        font-weight: 500;
        color: #FFFFFF;
    }
    .audithome_hright{
        width: 1.361111rem;
        height: 0.5rem;
        display: flex;
        justify-content: space-between;
    }
    .audithome_hrimg{
        width: 0.5rem;
        height: 0.5rem;
    }
    .audithome_hrimg img{
        display: block;
        width: 0.5rem;
        height: 0.5rem;
    }
    .audithome_tps{
        width: 100%;
        height: 0.833333rem;
        box-sizing: border-box;
        /* background: rgba(255,255,255,0.26);*/
        margin-top: 6px;
    }
    .audithome_tps span{
        width: 100%;
        height: 0.388889rem;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
        transform: scale(0.9);
        transform-origin:0 0;
        overflow: hidden;
        white-space:nowrap;
        -o-text-overflow:ellipsis;
        text-overflow:ellipsis;
    }
    /*.mobhome_tview{
        width: 100%;
        height: 100%;
        border-radius: 0.222222rem;
    }*/
    .mobhome_tview .sliderBox{
        margin: 0.35rem auto 0 auto;
    }
    .mobhome_tview .el-slider__bar{
        height: 0.138889rem !important;
        border-radius: 0.069444rem !important;
    }
    .mobhome_tview .el-slider__runway{
        height: 0.138889rem !important;
        border-radius: 0.069444rem !important;
    }
    .mobhome_tview .el-slider__button-wrapper{
        width: 0.972222rem !important;
        height: 0.972222rem !important;
        top: -0.388889rem !important;
    }
    .mobhome_tview .sliderbox_wrap{
        height: 1.694444rem;
    }
    .mobhome_tview .eshoy_slider_btns{
        width: 7.722222rem;
        height: 1.111111rem;
        margin-top: 0.42rem;
        margin-bottom: 0.277778rem;
    }
    .mobhome_tview .eshoy_slider_btn_view{
        width: 7.722222rem;
        height: 1.111111rem;
    }

    .moneybox {
        font-size: 0.833333rem;
        font-weight: 600;
        color: #333333;
        text-align: center;
        text-align: center;
        padding-bottom: 74px;
    }

    .moneybox span {
        font-size: 1.0rem;
    }

    .sliderBox {
        width: 6.2rem;
        height: auto;
        background: #E4EFEB;
        border-radius: 5px;
        margin: 24px auto 0 auto;
        position: relative;
    }

    .range {
        display: none;
        justify-content: space-between;
        margin-top: 35px;
    }

    .range p {
        font-size: 16px;
        color: #666;
        font-weight: 500;
    }

    .range p span {
        font-size: 18px;
    }
    .sliderbox_wrap{
        width: 100%;
        height: 1.194444rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    .sliderbox_left{
        width: 1.222222rem;
        height: 1.194444rem;
    }

    .sliderbox_right{
        width: 1.222222rem;
        height: 1.194444rem;
    }
    .sliderbox_cimg{
        width: 1.222222rem;
        height: 0.694444rem;
    }
    .sliderbox_ctext{
        width: 100%;
        height: 36px;
        font-size: 14px;
        font-weight: 500;
        color: #8C8480;
        line-height: 36px;
        text-align: center;
        position: relative;
    }
    .sliderbox_ctext span{
        padding-left: 6px;
    }
    .eshoy_slider_btns{
        width: 378px;
        height: 72px;
        margin: 80px auto 0 auto;
        cursor: pointer;
        position: relative;
    }
    .eshoy_slider_btn_view{
        width: 378px;
        height: 72px;
    }
    .eshoy_slider_btns img{
        display: block;
        width: 100%;
    }
</style>
<style>
    .confirmloan_wrap{
        width: 100%;
        height: 11rem;
        background: #F6F6F6;
        position: relative;
    }
    .confirmloan_cont{
        width: 100%;
        height: calc(100vh - 46px);
        position: absolute;
        left: 0;
        top: -9.0rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0.888889rem 0.444444rem 0 0.444444rem;
    }
    .confirmloan_ctoptitle{
        width: 100%;
        height: 0.833333rem;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #5A5A63;
        line-height: 0.388889rem;
    }
    .confirmloan_ctopdesc{
        width: 100%;
        height: 1.444444rem;
        font-size: 0.888889rem;
        font-weight: 500;
        color: #1A1A1A;
        line-height: 0.888889rem;
    }
    .confirmloan_ctopdesc span{
        font-size: 0.5rem;
        font-weight: bold;
        color: #1A1A1A;
        padding-right: 0.138889rem;
    }
    .confirmloan_cmain{
        width: 100%;
        height: auto;
        background: #ffffff;
        border-radius: 0.333333rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0.611111rem 0.444444rem 0 0.444444rem;
    }
    .confirmloan_cmtitle{
        width: 100%;
        height: 0.527778rem;
        font-size: 0.444444rem;
        font-weight: 500;
        color: #1A1A1A;
        line-height: 0.444444rem;
    }
    .confirmloan_cmview{
        width: 100%;
        height: auto;
    }
    .confirmloan_cmview .itoken_check_vitleft{
        color: #808080;
    }
    .confirmloan_cmitems{
        width: 100%;
        height: 1.611111rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .confirmloan_cmileft{
        width: auto;
        height: auto;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #808080;
    }
    .confirmloan_cmiright{
        width: auto;
        height: auto;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #1A1A1A;
    }
    .confirmloan_cmview .itoken_check_vitems{
        padding-top: 0.611111rem;
        padding-bottom: 0.611111rem;
    }
    .confirmloan_cmirview{
        width: auto;
        height: 0.666667rem;
        display: flex;
        justify-content: flex-start;
    }
    .confirmloan_cmirvl{
        width: auto;
        height: 0.666667rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #1A1A1A;
        line-height: 0.666667rem;
    }
    .confirmloan_cmirvl span{
        padding-right: 0.166667rem;
        color: #808080;
        text-decoration:line-through
    }
    .confirmloan_cmirvr{
        width: 0.666667rem;
        height: 0.666667rem;
        margin-left: 0.111111rem;
    }
    .confirmloan_cmirvr img{
        display: block;
        width: 100%;
        height: 100%;
    }
    .confirmloan_cmview .itoken_check_vitleft_coupon img{
        display: block;
        width: 0.444444rem;
        height: 0.444444rem;
    }
    .confirmloan_cmcontrato_wrap{
        width: 100%;
        height: auto;
        padding: 0.305556rem 0 1.361111rem 0;
    }
    .confirmloan_cmcontrato_cont{
        width: 100%;
        height: 0.666667rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .confirmloan_cmcontrato_cleft{
        width: auto;
        height: 0.666667rem;
        display: flex;
        align-items: center;
    }
    .confirmloan_cmcontrato_cleft img{
        display: block;
        width: 0.666667rem;
        height: 0.666667rem;
    }
    .confirmloan_cmcontrato_cleft .van-checkbox{
        width: auto;
        height: 0.666667rem;
    }
    .confirmloan_cmcontrato_cleft .van-checkbox__icon{
        width: 0.666667rem;
        height: 0.666667rem;
    }
    .confirmloan_cmcontrato_cleft .van-checkbox__label{
        width: auto;
        height: 0.666667rem;
        margin-left: 0.111111rem;
        font-size: 0.361111rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #999999;
        line-height: 0.666667rem;
    }
    .confirmloan_cmcontrato_cright{
        width: auto;
        height: 0.666667rem;
        margin-left: 0.111111rem;
        font-size: 0.361111rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #999999;
        line-height: 0.666667rem;
        text-decoration: underline;
    }
    .confirmloan_cmcontrato_cright span{
        color: #00CA88;
    }
    .confirmloan_msgwrap{
        width: 100%;
        height: auto;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0 0.444444rem 1.666667rem 0.444444rem;
    }
    .confirmloan_msgitems{
        width: 100%;
        height: 1.0rem;
        display: flex;
        justify-content: space-between;
    }
    .confirmloan_msgileft{
        width: auto;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #808080;
        line-height: 0.388889rem;
    }
    .confirmloan_msgiright{
        width: auto;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #1A1A1A;
        line-height: 0.388889rem;
    }
    .confirmloan_msgiright span{
        padding-left: 0.138889rem;
    }
    .confirmloan_cmview .itoken_check_vitems_coupons{
        padding-top: 0.485rem;
        padding-bottom: 0.485rem;
    }
    .itoken_check_vitems{
        width: 100%;
        height: auto;
        padding-top: 0.444444rem;
        padding-bottom: 0.444444rem;
    }
    .itoken_check_vitem{
        width: 100%;
        height: auto;
    }
    .itoken_check_vitop{
        width: 100%;
        height: 0.388889rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .itoken_check_vitleft{
        width: auto;
        height: 0.388889rem;
        font-size: 0.388889rem;
        font-weight: 400;
        color: #1A1A1A;
    }
    .itoken_check_vitright{
        width: auto;
        height: 0.388889rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 0.055556rem;
    }
    .itoken_check_vitop_new{
        height: 0.42rem;
    }
    .itoken_check_vitrnums{
        width: auto;
        height: 0.388889rem;
        display: flex;
        align-items: center;
        font-size: 0.388889rem;
        font-weight: 500;
        color: #1A1A1A;
    }
    .itoken_check_vitrnums span{
        font-size: 0.388889rem;
        font-weight: 500;
        color: #1A1A1A;
        padding-right: 0.111111rem;
    }
    .itoken_check_vitrarrow{
        width: 0.277778rem;
        height: 0.388889rem;
        margin-left: 0.111111rem;
    }
    .itoken_check_vitrarrow img{
        display: block;
        width: 100%;
    }
    .itoken_check_vidown{
        width: 100%;
        height: auto;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding-top: 0.25rem;
        padding-right: 0.388889rem;
        display: flex;
        justify-content: space-between;
    }
    .itoken_check_vidleft{
        width: auto;
        font-size: 0.333333rem;
        font-weight: 400;
        color: #808080;
    }
    .itoken_check_vidright{
        width: auto;
        font-size: 0.333333rem;
        font-weight: 400;
        color: #808080;
    }
    .itoken_check_vitleft_coupon{
        width: auto;
        height: 0.444444rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .itoken_check_vitleft_coupon img{
        display: block;
        width: 0.444444rem;
        height: 0.444444rem;
    }
    .itoken_check_vitleft_coupon span{
        padding-left: 0.166667rem;
        font-size: 0.361111rem;
        font-weight: 400;
        color: #808080;
    }
</style>
